var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-3 text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":50}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }